import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';

// Wraps the routed page content in App.js (keyed on the current path, so
// navigating away from a crashed page remounts this fresh). Without this,
// a single unhandled render error anywhere blanks the entire app to a
// white screen with no way back except a manual URL edit or hard refresh.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled error while rendering page:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 4, maxWidth: 480, mx: 'auto', textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            حصل خطأ غير متوقع فى عرض الصفحة دي.
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            جرب تفتح صفحة تانية من القائمة، أو أعد تحميل الصفحة.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            إعادة تحميل الصفحة
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
